export default __webpack_public_path__ + "ef41d908ec7681f8b2825fb17b3a0c71.png";